import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  CreateDoRequestActionOutput,
} from "../../lib";
import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";

export const REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND = "REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND";
export const doREQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND =
  createDoRequestAction<IdentityMfaEmailCodeResendRequestPayload>(
    REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND,
  );

export const requestIdentityMfaEmailCodeResendActionCreators = {
  doREQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND,
};

export type IdentityMfaEmailCodeResendRequestPayload = {
  email: string;
};

// Re-sends the email code the password step of an MFA login already issued, so the code the person
// has keeps working. The route answers 204 whether or not a code was pending.
export function* requestIdentityMfaEmailCodeResend({
  payload,
  setRequestResult,
}: CreateDoRequestActionOutput<IdentityMfaEmailCodeResendRequestPayload>): SagaIterator {
  debug("saga*requestIdentityMfaEmailCodeResend");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        email: v.string().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        { fromType: REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND, requestId: payload.requestId, error },
        setRequestResult,
      ),
    );
  }

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/identity-mfa-email-code-resend`,
    data: { email: payload.email },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug("saga*requestIdentityMfaEmailCodeResend failed", {
      statusCode: result.statusCode,
      type: result.type,
    });
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/identity-mfa-email-code-resend",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      { fromType: REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND, requestId: payload.requestId, ...result },
      setRequestResult,
    ),
  );
}

export function* identityMfaEmailCodeResendSaga() {
  yield takeEvery(REQUEST_IDENTITY_MFA_EMAIL_CODE_RESEND, requestIdentityMfaEmailCodeResend);
}
